import { Link } from "react-router-dom";

export function LogoMark({ size = 40 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            role="img"
            aria-label="The Sens Civil Works Consultancy logo"
            data-testid="logo-mark"
        >
            <rect width="64" height="64" fill="#0A1128" />
            <text
                x="32"
                y="43"
                fontFamily="IBM Plex Mono, monospace"
                fontSize="34"
                fontWeight="bold"
                fill="#F8F9FA"
                textAnchor="middle"
            >
                S
            </text>
            <rect x="8" y="52" width="48" height="4" fill="#FF5722" />
        </svg>
    );
}

export default function Logo({ dark = false }) {
    return (
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link" aria-label="The Sens Civil Works Consultancy — home">
            <LogoMark />
            <span className="leading-tight">
                <span className={`block font-display font-bold text-base tracking-tight ${dark ? "text-white" : "text-navy"}`}>
                    The Sens
                </span>
                <span className={`block font-mono text-[10px] uppercase tracking-[0.18em] ${dark ? "text-slate-400" : "text-slate-500"}`}>
                    Civil Works Consultancy
                </span>
            </span>
        </Link>
    );
}
